import { render, staticRenderFns } from "@/style-guide/partials/flatSelectorIconSwitch/flatSelectorIconSwitch.pug?vue&type=template&id=c0b7aa90&scoped=true&lang=pug&external"
import script from "./flatSelectorIconSwitch.vue?vue&type=script&lang=ts"
export * from "./flatSelectorIconSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b7aa90",
  null
  
)

export default component.exports